/**
 * Tiny calculator for rate boxes: "600/60" → 10, "820/20" → 41, "(600+50)/60" → 10.83.
 * Only digits, . + - * / and brackets are accepted; anything else returns null.
 */
export function evalArithmetic(input: string): number | null {
  const s = input.replace(/\s+/g, '').replace(/×/g, '*').replace(/÷/g, '/')
  if (!s || !/^[\d.+\-*/()]+$/.test(s)) return null
  let i = 0
  const peek = () => s[i]
  const parseNumber = (): number | null => {
    const m = /^\d*\.?\d+/.exec(s.slice(i))
    if (!m) return null
    i += m[0].length
    return Number(m[0])
  }
  const parseFactor = (): number | null => {
    if (peek() === '(') { i++; const v = parseExpr(); if (peek() !== ')') return null; i++; return v }
    if (peek() === '-') { i++; const v = parseFactor(); return v === null ? null : -v }
    if (peek() === '+') { i++; return parseFactor() }
    return parseNumber()
  }
  const parseTerm = (): number | null => {
    let v = parseFactor()
    while (v !== null && (peek() === '*' || peek() === '/')) {
      const op = s[i++]; const r = parseFactor(); if (r === null) return null
      v = op === '*' ? v * r : r === 0 ? null : v / r
    }
    return v
  }
  const parseExpr = (): number | null => {
    let v = parseTerm()
    while (v !== null && (peek() === '+' || peek() === '-')) {
      const op = s[i++]; const r = parseTerm(); if (r === null) return null
      v = op === '+' ? v + r : v - r
    }
    return v
  }
  const v = parseExpr()
  return i === s.length && v !== null && Number.isFinite(v) ? Math.round(v * 100) / 100 : null
}

/** True when the typed text is an expression (has an operator beyond a leading minus), so the result is worth showing. */
export const isExpression = (text: string) => /[+\-*/()]/.test(text.replace(/^-/, ''))
